import type { MetaFunction } from '@remix-run/node';
import { getInstanceBadge } from './instance';

export function getAppTitle(): string {
  const badge = getInstanceBadge();
  return badge ? `[${badge.name}] hhOS` : 'hhOS';
}

/**
 * Browser tab title. Pass parts most-specific first — `getPageTitle('Coverage', 'HCL')` renders
 * "Coverage | HCL | hhOS" — and empty parts are dropped, so a record name that hasn't loaded
 * doesn't leave a dangling separator.
 */
export function getPageTitle(...parts: (string | null | undefined)[]): string {
  const badge = getInstanceBadge();
  const prefix = badge ? `[${badge.name}] ` : '';
  return `${prefix}${[...parts.filter(Boolean), 'hhOS'].join(' | ')}`;
}

const HOME_ROUTE_ID = 'routes/_app+/homes+/$homeId';

/**
 * Tab title for a home detail tab: "4213 Dickason Ave | Visits | hhOS". A tab showing one item
 * passes `itemName` to lead with it: "Leaky faucet | 4213 Dickason Ave | Zendesk | hhOS".
 */
export function homeTabMeta(
  tab: string,
  itemName?: (data: unknown) => string | null | undefined
): MetaFunction {
  return ({ matches, data }) => {
    const home = matches.find((m) => m.id === HOME_ROUTE_ID)?.data as
      | { home?: { streetAddress?: string } }
      | undefined;
    return [{ title: getPageTitle(itemName?.(data), home?.home?.streetAddress, tab) }];
  };
}
